const BYPASS_STORAGE_KEY = 'browser_guard_bypass_accepted'

export function hasBypassedBrowserGuard(): boolean {
  return localStorage.getItem(BYPASS_STORAGE_KEY) === 'true'
}

export function setBrowserGuardBypassed(): void {
  localStorage.setItem(BYPASS_STORAGE_KEY, 'true')
}
